import {Injectable} from "@angular/core";
import {ApiService} from "~/app/core/api.service";

type Position = "top"|"left"|"right"|"bottom";

@Injectable()
export class GamificationService {
    constructor(
        private readonly api: ApiService,
    ) {
    }

    // createProgressImage(percent: number = 0.0): IBitmap {
    //     const size = 200;
    //     const outerSize = 200;
    //     const innerSize = 160;
    //
    //     const startAngle = -90;
    //     const sweepAngle = (360 * percent);
    //     const backgroundColor = {r: 0, g: 0, b: 0, a: 32};
    //     const innerColor = {r: 238, g: 32, b: 41, a: 255};
    //     let arcColor = {r: 0, g: 255, b: 0, a: 255};
    //     arcColor = innerColor;
    //     if (percent < 1) arcColor = {r: 255, g: 255, b: 0, a: 255};
    //
    //     const bmp = create(size, size);
    //     bmp.beginDrawing();
    //     bmp.drawArc({height: outerSize, width: outerSize}, {x: (size - outerSize) / 2, y: (size - outerSize) / 2}, 0, 360, backgroundColor, backgroundColor)
    //     bmp.drawArc({height: outerSize, width: outerSize}, {x: (size - outerSize) / 2, y: (size - outerSize) / 2}, startAngle, sweepAngle, arcColor, arcColor)
    //     bmp.drawArc({height: innerSize, width: innerSize}, {x: (size - innerSize) / 2, y: (size - innerSize) / 2}, 0, 360, innerColor, innerColor)
    //     bmp.drawArc({height: innerSize, width: innerSize}, {x: (size - innerSize) / 2, y: (size - innerSize) / 2}, 0, 360, innerColor, innerColor)
    //     bmp.finishDrawing();
    //     return bmp;
    // }
}
